<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>我的云店</BreadcrumbItem>
          <BreadcrumbItem to="/exhibition/index/proGroup/productlist">产品展示组</BreadcrumbItem>
          <BreadcrumbItem>添加展示组</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
      </div>
      <div class="f-tar" style="padding-top: 37px;">
        <Button @click="$router.push('/exhibition/index/proGroup/productlist')">返回</Button>
      </div>
    </div>
    <div class="custom-wrap">
      <!-- <div style="word-break: break-all;white-space: pre-wrap;">{{JSON.stringify(customData)}}</div> -->
      <customComponent v-model="customData" :type="3" ref="customComponent" :defaltArr="defaultData"></customComponent>
      <div class="custom-btn">
        <Button
          type="primary"
          size="large" 
          @click="saveCustom()"
          style="width: 154px;"
        >保存</Button>
      </div> 
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import customComponent from "@components/custom-component/custom-component";
export default {
  name: "product-group-add",
  data() {
    return {
      customData: [],
      groupData: null,
      otherData: [],
      defaultData: [
        {
          title: "产品分组",
          type: "product",
          icon: "",
          componentName: "customProduct",
          config: {
            type: 1,
            Name: "", // 分组名称
            ShowGroupName: 1, // 显示分组名称
            FirstPriority: 0, // 第一显示优先级
            SecondPriority: 0, // 第二显示优先级
            ListStyle: 1, // 列表样式
            ShowProductName: 1, // 显示产品的名称
            ShowProductPrice: 1, // 显示产品的价格
            Introduction: "" // 分组的描述
          }
        }
      ]
    };
  },
  components: {
    customComponent
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    })
  },
  methods: {
    ...mapActions({
      addProductGroup: "productModule/addProductGroup",
      transformReqCustomData: "customComponentModule/transformReqCustomData"
    }),
    async saveCustom() {
      this.$refs["customComponent"].saveCustom();
      setTimeout(() => {
        console.log("展示组信息：",this.customData);
        const req = this.transformData();
        console.log(req);
        if (req.Name === "") {
          this.$Message.error("分组名称不能为空!");
          return;
        }
        this.addGroup(req);
      }, 400);
    },
    transformData() {
      if (!this.customData) return;
      let data = [];
      let copyData = JSON.parse(JSON.stringify(this.customData));
      copyData.forEach(c => {
        const key = Object.keys(c);
        if (key && key[0] === "product") {
          this.groupData = c.product;
        } else {
          data.push(c);
        }
      });
      this.otherData = data;
      const req = {
        CompId: this.company.id,
        AgentId: this.company.agentId,
        Name: this.groupData.Name,
        ShowGroupName: this.groupData.ShowGroupName,
        FirstPriority: this.groupData.FirstPriority,
        SecondPriority: this.groupData.SecondPriority,
        ListStyle: this.groupData.ListStyle,
        ShowBuyButton: 0,
        BuyButtonStyle: 1,
        ShowProductName: this.groupData.ShowProductName,
        ShowProductPrice: this.groupData.ShowProductPrice,
        Introduction: JSON.stringify(this.otherData)
      };
      console.log(req);
      return req;
    },
    async addGroup(req) {
      const bool = await this.addProductGroup(req);
      console.log(bool);
      if (!bool) {
        this.$Message.error("保存失败!");
        return false;
      }
      if (!bool.successed) {
        this.$Message.error(bool.msg);
        this.formInline.captcha = "";
        return;
      }
      this.$Message.success("保存成功!");
      this.$router.push("/exhibition/index/proGroup/productlist");
    }
  }
};
</script>

<style scoped lang="scss">
.custom-wrap {
  margin: 40px auto;
  min-height: 500px;
}
.custom-btn { 
  margin: 0 auto;  
  width: 968px; 
}
</style>
